import React from 'react';
import "./styles.css";
import { ImageAsset } from "res";

export default function MobileWrapper(props) {
  // Get the location of the window
  const location = window.location.href;
  // Get rid of the hash and everything after
  const src = location.slice(0, location.indexOf("#"));

  return(
    <div className="mobile-page flex-container all-center">
      <div className="phone-wrapper">
          <iframe title="mobile-demo" src={ src }></iframe>
      </div>
    </div>
  );
}